module.exports = __webpack_public_path__ + "img/Friend.0b9dcdb1.svg";